import { defineComponent as zn, ref as J, computed as Oe, watch as ue, nextTick as Rn, resolveComponent as ke, createElementBlock as De, createCommentVNode as ct, openBlock as K, createElementVNode as z, toDisplayString as Ue, createVNode as U, mergeProps as dt, withCtx as le, normalizeClass as ft, withModifiers as Me, createBlock as mt, Fragment as Un, renderList as Wn } from "vue";
import { D as qn, C as Hn } from "./index-DQ1kEltI.mjs";
import { v as Pn } from "./vsIcon-Cyr63bPF.mjs";
import { v as Yn } from "./vsButton-BlFL21k0.mjs";
import { v as Jn } from "./vsBadge-DmDe4A9x.mjs";
import { _ as Gn } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
class Q extends Error {
}
class Bn extends Q {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class jn extends Q {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class _n extends Q {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class he extends Q {
}
class Zt extends Q {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class C extends Q {
}
class H extends Q {
  constructor() {
    super("Zone is an abstract class");
  }
}
const c = "numeric", A = "short", I = "long", je = {
  year: c,
  month: c,
  day: c
}, zt = {
  year: c,
  month: A,
  day: c
}, Qn = {
  year: c,
  month: A,
  day: c,
  weekday: A
}, Rt = {
  year: c,
  month: I,
  day: c
}, Ut = {
  year: c,
  month: I,
  day: c,
  weekday: I
}, Wt = {
  hour: c,
  minute: c
}, qt = {
  hour: c,
  minute: c,
  second: c
}, Ht = {
  hour: c,
  minute: c,
  second: c,
  timeZoneName: A
}, Pt = {
  hour: c,
  minute: c,
  second: c,
  timeZoneName: I
}, Yt = {
  hour: c,
  minute: c,
  hourCycle: "h23"
}, Jt = {
  hour: c,
  minute: c,
  second: c,
  hourCycle: "h23"
}, Gt = {
  hour: c,
  minute: c,
  second: c,
  hourCycle: "h23",
  timeZoneName: A
}, Bt = {
  hour: c,
  minute: c,
  second: c,
  hourCycle: "h23",
  timeZoneName: I
}, jt = {
  year: c,
  month: c,
  day: c,
  hour: c,
  minute: c
}, _t = {
  year: c,
  month: c,
  day: c,
  hour: c,
  minute: c,
  second: c
}, Qt = {
  year: c,
  month: A,
  day: c,
  hour: c,
  minute: c
}, Kt = {
  year: c,
  month: A,
  day: c,
  hour: c,
  minute: c,
  second: c
}, Kn = {
  year: c,
  month: A,
  day: c,
  weekday: A,
  hour: c,
  minute: c
}, Xt = {
  year: c,
  month: I,
  day: c,
  hour: c,
  minute: c,
  timeZoneName: A
}, en = {
  year: c,
  month: I,
  day: c,
  hour: c,
  minute: c,
  second: c,
  timeZoneName: A
}, tn = {
  year: c,
  month: I,
  day: c,
  weekday: I,
  hour: c,
  minute: c,
  timeZoneName: I
}, nn = {
  year: c,
  month: I,
  day: c,
  weekday: I,
  hour: c,
  minute: c,
  second: c,
  timeZoneName: I
};
function y(t) {
  return typeof t > "u";
}
function _(t) {
  return typeof t == "number";
}
function Ae(t) {
  return typeof t == "number" && t % 1 === 0;
}
function Xn(t) {
  return typeof t == "string";
}
function er(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function rn() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function tr(t) {
  return Array.isArray(t) ? t : [t];
}
function ht(t, e, n) {
  if (t.length !== 0)
    return t.reduce((r, s) => {
      const a = [e(s), s];
      return r && n(r[0], a[0]) === r[0] ? r : a;
    }, null)[1];
}
function nr(t, e) {
  return e.reduce((n, r) => (n[r] = t[r], n), {});
}
function te(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function W(t, e, n) {
  return Ae(t) && t >= e && t <= n;
}
function rr(t, e) {
  return t - e * Math.floor(t / e);
}
function D(t, e = 2) {
  const n = t < 0;
  let r;
  return n ? r = "-" + ("" + -t).padStart(e, "0") : r = ("" + t).padStart(e, "0"), r;
}
function P(t) {
  if (!(y(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function G(t) {
  if (!(y(t) || t === null || t === ""))
    return parseFloat(t);
}
function nt(t) {
  if (!(y(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function rt(t, e, n = !1) {
  const r = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * r) / r;
}
function pe(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function ge(t) {
  return pe(t) ? 366 : 365;
}
function Ve(t, e) {
  const n = rr(e - 1, 12) + 1, r = t + (e - n) / 12;
  return n === 2 ? pe(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function st(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(e.getUTCFullYear() - 1900)), +e;
}
function $e(t) {
  const e = (t + Math.floor(t / 4) - Math.floor(t / 100) + Math.floor(t / 400)) % 7, n = t - 1, r = (n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400)) % 7;
  return e === 4 || r === 3 ? 53 : 52;
}
function _e(t) {
  return t > 99 ? t : t > 60 ? 1900 + t : 2e3 + t;
}
function sn(t, e, n, r = null) {
  const s = new Date(t), a = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (a.timeZone = r);
  const i = { timeZoneName: e, ...a }, o = new Intl.DateTimeFormat(n, i).formatToParts(s).find((u) => u.type.toLowerCase() === "timezonename");
  return o ? o.value : null;
}
function Ze(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(e, 10) || 0, s = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + s;
}
function an(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new C(`Invalid unit value ${t}`);
  return e;
}
function Le(t, e) {
  const n = {};
  for (const r in t)
    if (te(t, r)) {
      const s = t[r];
      if (s == null) continue;
      n[e(r)] = an(s);
    }
  return n;
}
function we(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), r = Math.trunc(Math.abs(t % 60)), s = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${s}${D(n, 2)}:${D(r, 2)}`;
    case "narrow":
      return `${s}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${s}${D(n, 2)}${D(r, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function ze(t) {
  return nr(t, ["hour", "minute", "second", "millisecond"]);
}
const on = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/, sr = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], un = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], ir = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function ln(t) {
  switch (t) {
    case "narrow":
      return [...ir];
    case "short":
      return [...un];
    case "long":
      return [...sr];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const cn = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], dn = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], ar = ["M", "T", "W", "T", "F", "S", "S"];
function fn(t) {
  switch (t) {
    case "narrow":
      return [...ar];
    case "short":
      return [...dn];
    case "long":
      return [...cn];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const mn = ["AM", "PM"], or = ["Before Christ", "Anno Domini"], ur = ["BC", "AD"], lr = ["B", "A"];
function hn(t) {
  switch (t) {
    case "narrow":
      return [...lr];
    case "short":
      return [...ur];
    case "long":
      return [...or];
    default:
      return null;
  }
}
function cr(t) {
  return mn[t.hour < 12 ? 0 : 1];
}
function dr(t, e) {
  return fn(e)[t.weekday - 1];
}
function fr(t, e) {
  return ln(e)[t.month - 1];
}
function mr(t, e) {
  return hn(e)[t.year < 0 ? 0 : 1];
}
function hr(t, e, n = "always", r = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, a = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && a) {
    const p = t === "days";
    switch (e) {
      case 1:
        return p ? "tomorrow" : `next ${s[t][0]}`;
      case -1:
        return p ? "yesterday" : `last ${s[t][0]}`;
      case 0:
        return p ? "today" : `this ${s[t][0]}`;
    }
  }
  const i = Object.is(e, -0) || e < 0, o = Math.abs(e), u = o === 1, l = s[t], d = r ? u ? l[1] : l[2] || l[1] : u ? s[t][0] : t;
  return i ? `${o} ${d} ago` : `in ${o} ${d}`;
}
function yt(t, e) {
  let n = "";
  for (const r of t)
    r.literal ? n += r.val : n += e(r.val);
  return n;
}
const yr = {
  D: je,
  DD: zt,
  DDD: Rt,
  DDDD: Ut,
  t: Wt,
  tt: qt,
  ttt: Ht,
  tttt: Pt,
  T: Yt,
  TT: Jt,
  TTT: Gt,
  TTTT: Bt,
  f: jt,
  ff: Qt,
  fff: Xt,
  ffff: tn,
  F: _t,
  FF: Kt,
  FFF: en,
  FFFF: nn
};
class b {
  static create(e, n = {}) {
    return new b(e, n);
  }
  static parseFormat(e) {
    let n = null, r = "", s = !1;
    const a = [];
    for (let i = 0; i < e.length; i++) {
      const o = e.charAt(i);
      o === "'" ? (r.length > 0 && a.push({ literal: s, val: r }), n = null, r = "", s = !s) : s || o === n ? r += o : (r.length > 0 && a.push({ literal: !1, val: r }), r = o, n = o);
    }
    return r.length > 0 && a.push({ literal: s, val: r }), a;
  }
  static macroTokenToFormatOpts(e) {
    return yr[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  formatDateTime(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  formatDateTimeParts(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).formatToParts();
  }
  resolvedOptions(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return D(e, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(e);
  }
  formatDateTimeFromString(e, n) {
    const r = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", a = (m, T) => this.loc.extract(e, m, T), i = (m) => e.isOffsetFixed && e.offset === 0 && m.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, m.format) : "", o = () => r ? cr(e) : a({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), u = (m, T) => r ? fr(e, m) : a(T ? { month: m } : { month: m, day: "numeric" }, "month"), l = (m, T) => r ? dr(e, m) : a(
      T ? { weekday: m } : { weekday: m, month: "long", day: "numeric" },
      "weekday"
    ), d = (m) => {
      const T = b.macroTokenToFormatOpts(m);
      return T ? this.formatWithSystemDefault(e, T) : m;
    }, p = (m) => r ? mr(e, m) : a({ era: m }, "era"), v = (m) => {
      switch (m) {
        // ms
        case "S":
          return this.num(e.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(e.millisecond, 3);
        // seconds
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        // minutes
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        // hours
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        // offset
        case "Z":
          return i({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return i({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return i({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return e.zoneName;
        // meridiems
        case "a":
          return o();
        // dates
        case "d":
          return s ? a({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return s ? a({ day: "2-digit" }, "day") : this.num(e.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return l("short", !0);
        case "cccc":
          return l("long", !0);
        case "ccccc":
          return l("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return l("short", !1);
        case "EEEE":
          return l("long", !1);
        case "EEEEE":
          return l("narrow", !1);
        // months - standalone
        case "L":
          return s ? a({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return s ? a({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return u("short", !0);
        case "LLLL":
          return u("long", !0);
        case "LLLLL":
          return u("narrow", !0);
        // months - format
        case "M":
          return s ? a({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return s ? a({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return u("short", !1);
        case "MMMM":
          return u("long", !1);
        case "MMMMM":
          return u("narrow", !1);
        // years
        case "y":
          return s ? a({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return s ? a({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? a({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return s ? a({ year: "numeric" }, "year") : this.num(e.year, 6);
        // eras
        case "G":
          return p("short");
        case "GG":
          return p("long");
        case "GGGGG":
          return p("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return d(m);
      }
    };
    return yt(b.parseFormat(n), v);
  }
  formatDurationFromString(e, n) {
    const r = (u) => {
      switch (u[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, s = (u) => (l) => {
      const d = r(l);
      return d ? this.num(u.get(d), l.length) : l;
    }, a = b.parseFormat(n), i = a.reduce(
      (u, { literal: l, val: d }) => l ? u : u.concat(d),
      []
    ), o = e.shiftTo(...i.map(r).filter((u) => u));
    return yt(a, s(o));
  }
}
class L {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
class Te {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new H();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new H();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new H();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new H();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new H();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new H();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new H();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new H();
  }
}
let We = null;
class it extends Te {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return We === null && (We = new it()), We;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return sn(e, n, r);
  }
  /** @override **/
  formatOffset(e, n) {
    return we(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let Ce = {};
function gr(t) {
  return Ce[t] || (Ce[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Ce[t];
}
const wr = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function pr(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, s, a, i, o, u, l, d] = r;
  return [i, s, a, o, u, l, d];
}
function Tr(t, e) {
  const n = t.formatToParts(e), r = [];
  for (let s = 0; s < n.length; s++) {
    const { type: a, value: i } = n[s], o = wr[a];
    a === "era" ? r[o] = i : y(o) || (r[o] = parseInt(i, 10));
  }
  return r;
}
let Ee = {};
class q extends Te {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return Ee[e] || (Ee[e] = new q(e)), Ee[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Ee = {}, Ce = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = q.isValidZone(e);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return sn(e, n, r, this.name);
  }
  /** @override **/
  formatOffset(e, n) {
    return we(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const r = gr(this.name);
    let [s, a, i, o, u, l, d] = r.formatToParts ? Tr(r, n) : pr(r, n);
    o === "BC" && (s = -Math.abs(s) + 1);
    const v = st({
      year: s,
      month: a,
      day: i,
      hour: u === 24 ? 0 : u,
      minute: l,
      second: d,
      millisecond: 0
    });
    let m = +n;
    const T = m % 1e3;
    return m -= T >= 0 ? T : 1e3 + T, (v - m) / (60 * 1e3);
  }
  /** @override **/
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let qe = null;
class N extends Te {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return qe === null && (qe = new N(0)), qe;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? N.utcInstance : new N(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new N(Ze(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${we(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${we(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(e, n) {
    return we(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class vr extends Te {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Y(t, e) {
  if (y(t) || t === null)
    return e;
  if (t instanceof Te)
    return t;
  if (Xn(t)) {
    const n = t.toLowerCase();
    return n === "local" || n === "system" ? e : n === "utc" || n === "gmt" ? N.utcInstance : N.parseSpecifier(n) || q.create(t);
  } else return _(t) ? N.instance(t) : typeof t == "object" && t.offset && typeof t.offset == "number" ? t : new vr(t);
}
let gt = () => Date.now(), wt = "system", pt = null, Tt = null, vt = null, St;
class M {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return gt;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    gt = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    wt = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Y(wt, it.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return pt;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    pt = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Tt;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    Tt = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return vt;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    vt = e;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return St;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    St = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    O.resetCache(), q.resetCache();
  }
}
let Ot = {};
function Sr(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Ot[n];
  return r || (r = new Intl.ListFormat(t, e), Ot[n] = r), r;
}
let Qe = {};
function Ke(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Qe[n];
  return r || (r = new Intl.DateTimeFormat(t, e), Qe[n] = r), r;
}
let Xe = {};
function Or(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Xe[n];
  return r || (r = new Intl.NumberFormat(t, e), Xe[n] = r), r;
}
let et = {};
function kr(t, e = {}) {
  const { base: n, ...r } = e, s = JSON.stringify([t, r]);
  let a = et[s];
  return a || (a = new Intl.RelativeTimeFormat(t, e), et[s] = a), a;
}
let ye = null;
function Dr() {
  return ye || (ye = new Intl.DateTimeFormat().resolvedOptions().locale, ye);
}
function Mr(t) {
  const e = t.indexOf("-u-");
  if (e === -1)
    return [t];
  {
    let n;
    const r = t.substring(0, e);
    try {
      n = Ke(t).resolvedOptions();
    } catch {
      n = Ke(r).resolvedOptions();
    }
    const { numberingSystem: s, calendar: a } = n;
    return [r, s, a];
  }
}
function Er(t, e, n) {
  return (n || e) && (t += "-u", n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function Nr(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const r = h.utc(2016, n, 1);
    e.push(t(r));
  }
  return e;
}
function br(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const r = h.utc(2016, 11, 13 + n);
    e.push(t(r));
  }
  return e;
}
function Ne(t, e, n, r, s) {
  const a = t.listingMode(n);
  return a === "error" ? null : a === "en" ? r(e) : s(e);
}
function Ir(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class xr {
  constructor(e, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: s, floor: a, ...i } = r;
    if (!n || Object.keys(i).length > 0) {
      const o = { useGrouping: !1, ...r };
      r.padTo > 0 && (o.minimumIntegerDigits = r.padTo), this.inf = Or(e, o);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : rt(e, 3);
      return D(n, this.padTo);
    }
  }
}
class Cr {
  constructor(e, n, r) {
    this.opts = r;
    let s;
    if (e.zone.isUniversal) {
      const i = -1 * (e.offset / 60), o = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`;
      e.offset !== 0 && q.create(o).valid ? (s = o, this.dt = e) : (s = "UTC", r.timeZoneName ? this.dt = e : this.dt = e.offset === 0 ? e : h.fromMillis(e.ts + e.offset * 60 * 1e3));
    } else e.zone.type === "system" ? this.dt = e : (this.dt = e, s = e.zone.name);
    const a = { ...this.opts };
    s && (a.timeZone = s), this.dtf = Ke(n, a);
  }
  format() {
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class Fr {
  constructor(e, n, r) {
    this.opts = { style: "long", ...r }, !n && rn() && (this.rtf = kr(e, r));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : hr(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
class O {
  static fromOpts(e) {
    return O.create(e.locale, e.numberingSystem, e.outputCalendar, e.defaultToEN);
  }
  static create(e, n, r, s = !1) {
    const a = e || M.defaultLocale, i = a || (s ? "en-US" : Dr()), o = n || M.defaultNumberingSystem, u = r || M.defaultOutputCalendar;
    return new O(i, o, u, a);
  }
  static resetCache() {
    ye = null, Qe = {}, Xe = {}, et = {};
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    return O.create(e, n, r);
  }
  constructor(e, n, r, s) {
    const [a, i, o] = Mr(e);
    this.locale = a, this.numberingSystem = n || i || null, this.outputCalendar = r || o || null, this.intl = Er(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = s, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = Ir(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : O.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1, r = !0) {
    return Ne(this, e, r, ln, () => {
      const s = n ? { month: e, day: "numeric" } : { month: e }, a = n ? "format" : "standalone";
      return this.monthsCache[a][e] || (this.monthsCache[a][e] = Nr((i) => this.extract(i, s, "month"))), this.monthsCache[a][e];
    });
  }
  weekdays(e, n = !1, r = !0) {
    return Ne(this, e, r, fn, () => {
      const s = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, a = n ? "format" : "standalone";
      return this.weekdaysCache[a][e] || (this.weekdaysCache[a][e] = br(
        (i) => this.extract(i, s, "weekday")
      )), this.weekdaysCache[a][e];
    });
  }
  meridiems(e = !0) {
    return Ne(
      this,
      void 0,
      e,
      () => mn,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [h.utc(2016, 11, 13, 9), h.utc(2016, 11, 13, 19)].map(
            (r) => this.extract(r, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e, n = !0) {
    return Ne(this, e, n, hn, () => {
      const r = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [h.utc(-40, 1, 1), h.utc(2017, 1, 1)].map(
        (s) => this.extract(s, r, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, r) {
    const s = this.dtFormatter(e, n), a = s.formatToParts(), i = a.find((o) => o.type.toLowerCase() === r);
    return i ? i.value : null;
  }
  numberFormatter(e = {}) {
    return new xr(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new Cr(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new Fr(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return Sr(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
}
function ne(...t) {
  const e = t.reduce((n, r) => n + r.source, "");
  return RegExp(`^${e}$`);
}
function re(...t) {
  return (e) => t.reduce(
    ([n, r, s], a) => {
      const [i, o, u] = a(e, s);
      return [{ ...n, ...i }, o || r, u];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function se(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, r] of e) {
    const s = n.exec(t);
    if (s)
      return r(s);
  }
  return [null, null];
}
function yn(...t) {
  return (e, n) => {
    const r = {};
    let s;
    for (s = 0; s < t.length; s++)
      r[t[s]] = P(e[n + s]);
    return [r, null, n + s];
  };
}
const gn = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, Vr = `(?:${gn.source}?(?:\\[(${on.source})\\])?)?`, at = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, wn = RegExp(`${at.source}${Vr}`), ot = RegExp(`(?:T${wn.source})?`), $r = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, Lr = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Ar = /(\d{4})-?(\d{3})/, Zr = yn("weekYear", "weekNumber", "weekDay"), zr = yn("year", "ordinal"), Rr = /(\d{4})-(\d\d)-(\d\d)/, pn = RegExp(
  `${at.source} ?(?:${gn.source}|(${on.source}))?`
), Ur = RegExp(`(?: ${pn.source})?`);
function ee(t, e, n) {
  const r = t[e];
  return y(r) ? n : P(r);
}
function Wr(t, e) {
  return [{
    year: ee(t, e),
    month: ee(t, e + 1, 1),
    day: ee(t, e + 2, 1)
  }, null, e + 3];
}
function ie(t, e) {
  return [{
    hours: ee(t, e, 0),
    minutes: ee(t, e + 1, 0),
    seconds: ee(t, e + 2, 0),
    milliseconds: nt(t[e + 3])
  }, null, e + 4];
}
function ve(t, e) {
  const n = !t[e] && !t[e + 1], r = Ze(t[e + 1], t[e + 2]), s = n ? null : N.instance(r);
  return [{}, s, e + 3];
}
function Se(t, e) {
  const n = t[e] ? q.create(t[e]) : null;
  return [{}, n, e + 1];
}
const qr = RegExp(`^T?${at.source}$`), Hr = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Pr(t) {
  const [
    e,
    n,
    r,
    s,
    a,
    i,
    o,
    u,
    l
  ] = t, d = e[0] === "-", p = u && u[0] === "-", v = (m, T = !1) => m !== void 0 && (T || m && d) ? -m : m;
  return [
    {
      years: v(G(n)),
      months: v(G(r)),
      weeks: v(G(s)),
      days: v(G(a)),
      hours: v(G(i)),
      minutes: v(G(o)),
      seconds: v(G(u), u === "-0"),
      milliseconds: v(nt(l), p)
    }
  ];
}
const Yr = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ut(t, e, n, r, s, a, i) {
  const o = {
    year: e.length === 2 ? _e(P(e)) : P(e),
    month: un.indexOf(n) + 1,
    day: P(r),
    hour: P(s),
    minute: P(a)
  };
  return i && (o.second = P(i)), t && (o.weekday = t.length > 3 ? cn.indexOf(t) + 1 : dn.indexOf(t) + 1), o;
}
const Jr = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Gr(t) {
  const [
    ,
    e,
    n,
    r,
    s,
    a,
    i,
    o,
    u,
    l,
    d,
    p
  ] = t, v = ut(e, s, r, n, a, i, o);
  let m;
  return u ? m = Yr[u] : l ? m = 0 : m = Ze(d, p), [v, new N(m)];
}
function Br(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const jr = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, _r = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Qr = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function kt(t) {
  const [, e, n, r, s, a, i, o] = t;
  return [ut(e, s, r, n, a, i, o), N.utcInstance];
}
function Kr(t) {
  const [, e, n, r, s, a, i, o] = t;
  return [ut(e, o, n, r, s, a, i), N.utcInstance];
}
const Xr = ne($r, ot), es = ne(Lr, ot), ts = ne(Ar, ot), ns = ne(wn), Tn = re(
  Wr,
  ie,
  ve,
  Se
), rs = re(
  Zr,
  ie,
  ve,
  Se
), ss = re(
  zr,
  ie,
  ve,
  Se
), is = re(
  ie,
  ve,
  Se
);
function as(t) {
  return se(
    t,
    [Xr, Tn],
    [es, rs],
    [ts, ss],
    [ns, is]
  );
}
function os(t) {
  return se(Br(t), [Jr, Gr]);
}
function us(t) {
  return se(
    t,
    [jr, kt],
    [_r, kt],
    [Qr, Kr]
  );
}
function ls(t) {
  return se(t, [Hr, Pr]);
}
const cs = re(ie);
function ds(t) {
  return se(t, [qr, cs]);
}
const fs = ne(Rr, Ur), ms = ne(pn), hs = re(
  ie,
  ve,
  Se
);
function ys(t) {
  return se(
    t,
    [fs, Tn],
    [ms, hs]
  );
}
const gs = "Invalid Duration", vn = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, ws = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...vn
}, x = 146097 / 400, X = 146097 / 4800, ps = {
  years: {
    quarters: 4,
    months: 12,
    weeks: x / 7,
    days: x,
    hours: x * 24,
    minutes: x * 24 * 60,
    seconds: x * 24 * 60 * 60,
    milliseconds: x * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: x / 28,
    days: x / 4,
    hours: x * 24 / 4,
    minutes: x * 24 * 60 / 4,
    seconds: x * 24 * 60 * 60 / 4,
    milliseconds: x * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: X / 7,
    days: X,
    hours: X * 24,
    minutes: X * 24 * 60,
    seconds: X * 24 * 60 * 60,
    milliseconds: X * 24 * 60 * 60 * 1e3
  },
  ...vn
}, j = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Ts = j.slice(0).reverse();
function B(t, e, n = !1) {
  const r = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy
  };
  return new g(r);
}
function vs(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function Sn(t, e, n, r, s) {
  const a = t[s][n], i = e[n] / a, o = Math.sign(i) === Math.sign(r[s]), u = !o && r[s] !== 0 && Math.abs(i) <= 1 ? vs(i) : Math.trunc(i);
  r[s] += u, e[n] -= u * a;
}
function Ss(t, e) {
  Ts.reduce((n, r) => y(e[r]) ? n : (n && Sn(t, e, n, e, r), r), null);
}
class g {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    this.values = e.values, this.loc = e.loc || O.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = n ? ps : ws, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return g.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new C(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new g({
      values: Le(e, g.normalizeUnit),
      loc: O.fromObject(n),
      conversionAccuracy: n.conversionAccuracy
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (_(e))
      return g.fromMillis(e);
    if (g.isDuration(e))
      return e;
    if (typeof e == "object")
      return g.fromObject(e);
    throw new C(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [r] = ls(e);
    return r ? g.fromObject(r, n) : g.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [r] = ds(e);
    return r ? g.fromObject(r, n) : g.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new C("need to specify a reason the Duration is invalid");
    const r = e instanceof L ? e : new L(e, n);
    if (M.throwOnInvalid)
      throw new _n(r);
    return new g({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new Zt(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? b.create(this.loc, r).formatDurationFromString(this, e) : gs;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    const n = j.map((r) => {
      const s = this.values[r];
      return y(s) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: r.slice(0, -1) }).format(s);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += rt(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    if (n < 0 || n >= 864e5) return null;
    e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e
    };
    const r = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let s = e.format === "basic" ? "hhmm" : "hh:mm";
    (!e.suppressSeconds || r.seconds !== 0 || r.milliseconds !== 0) && (s += e.format === "basic" ? "ss" : ":ss", (!e.suppressMilliseconds || r.milliseconds !== 0) && (s += ".SSS"));
    let a = r.toFormat(s);
    return e.includePrefix && (a = "T" + a), a;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = g.fromDurationLike(e), r = {};
    for (const s of j)
      (te(n.values, s) || te(this.values, s)) && (r[s] = n.get(s) + this.get(s));
    return B(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = g.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = an(e(this.values[r], r));
    return B(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[g.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...Le(e, g.normalizeUnit) };
    return B(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: r } = {}) {
    const s = this.loc.clone({ locale: e, numberingSystem: n }), a = { loc: s };
    return r && (a.conversionAccuracy = r), B(this, a);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return Ss(this.matrix, e), B(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((i) => g.normalizeUnit(i));
    const n = {}, r = {}, s = this.toObject();
    let a;
    for (const i of j)
      if (e.indexOf(i) >= 0) {
        a = i;
        let o = 0;
        for (const l in r)
          o += this.matrix[l][i] * r[l], r[l] = 0;
        _(s[i]) && (o += s[i]);
        const u = Math.trunc(o);
        n[i] = u, r[i] = (o * 1e3 - u * 1e3) / 1e3;
        for (const l in s)
          j.indexOf(l) > j.indexOf(i) && Sn(this.matrix, s, l, n, i);
      } else _(s[i]) && (r[i] = s[i]);
    for (const i in r)
      r[i] !== 0 && (n[a] += i === a ? r[i] : r[i] / this.matrix[a][i]);
    return B(this, { values: n }, !0).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return B(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(r, s) {
      return r === void 0 || r === 0 ? s === void 0 || s === 0 : r === s;
    }
    for (const r of j)
      if (!n(this.values[r], e.values[r]))
        return !1;
    return !0;
  }
}
const ce = "Invalid Interval";
function Os(t, e) {
  return !t || !t.isValid ? k.invalid("missing or invalid start") : !e || !e.isValid ? k.invalid("missing or invalid end") : e < t ? k.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class k {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new C("need to specify a reason the Interval is invalid");
    const r = e instanceof L ? e : new L(e, n);
    if (M.throwOnInvalid)
      throw new jn(r);
    return new k({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const r = me(e), s = me(n), a = Os(r, s);
    return a ?? new k({
      start: r,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const r = g.fromDurationLike(n), s = me(e);
    return k.fromDateTimes(s, s.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const r = g.fromDurationLike(n), s = me(e);
    return k.fromDateTimes(s.minus(r), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [r, s] = (e || "").split("/", 2);
    if (r && s) {
      let a, i;
      try {
        a = h.fromISO(r, n), i = a.isValid;
      } catch {
        i = !1;
      }
      let o, u;
      try {
        o = h.fromISO(s, n), u = o.isValid;
      } catch {
        u = !1;
      }
      if (i && u)
        return k.fromDateTimes(a, o);
      if (i) {
        const l = g.fromISO(s, n);
        if (l.isValid)
          return k.after(a, l);
      } else if (u) {
        const l = g.fromISO(r, n);
        if (l.isValid)
          return k.before(o, l);
      }
    }
    return k.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(e = "milliseconds") {
    if (!this.isValid) return NaN;
    const n = this.start.startOf(e), r = this.end.startOf(e);
    return Math.floor(r.diff(n, e).get(e)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? k.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(me).filter((i) => this.contains(i)).sort(), r = [];
    let { s } = this, a = 0;
    for (; s < this.e; ) {
      const i = n[a] || this.e, o = +i > +this.e ? this.e : i;
      r.push(k.fromDateTimes(s, o)), s = o, a += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = g.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, s = 1, a;
    const i = [];
    for (; r < this.e; ) {
      const o = this.start.plus(n.mapUnits((u) => u * s));
      a = +o > +this.e ? this.e : o, i.push(k.fromDateTimes(r, a)), r = a, s += 1;
    }
    return i;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, r = this.e < e.e ? this.e : e.e;
    return n >= r ? null : k.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, r = this.e > e.e ? this.e : e.e;
    return k.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, r] = e.sort((s, a) => s.s - a.s).reduce(
      ([s, a], i) => a ? a.overlaps(i) || a.abutsStart(i) ? [s, a.union(i)] : [s.concat([a]), i] : [s, i],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, r = 0;
    const s = [], a = e.map((u) => [
      { time: u.s, type: "s" },
      { time: u.e, type: "e" }
    ]), i = Array.prototype.concat(...a), o = i.sort((u, l) => u.time - l.time);
    for (const u of o)
      r += u.type === "s" ? 1 : -1, r === 1 ? n = u.time : (n && +n != +u.time && s.push(k.fromDateTimes(n, u.time)), n = null);
    return k.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return k.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : ce;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : ce;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : ce;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : ce;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : ce;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : g.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return k.fromDateTimes(e(this.s), e(this.e));
  }
}
class be {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = M.defaultZone) {
    const n = h.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return q.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return Y(e, M.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null, outputCalendar: a = "gregory" } = {}) {
    return (s || O.create(n, r, a)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null, outputCalendar: a = "gregory" } = {}) {
    return (s || O.create(n, r, a)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null } = {}) {
    return (s || O.create(n, r, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: s = null } = {}) {
    return (s || O.create(n, r, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return O.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return O.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: rn() };
  }
}
function Dt(t, e) {
  const n = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(e) - n(t);
  return Math.floor(g.fromMillis(r).as("days"));
}
function ks(t, e, n) {
  const r = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const l = Dt(o, u);
        return (l - l % 7) / 7;
      }
    ],
    ["days", Dt]
  ], s = {};
  let a, i;
  for (const [o, u] of r)
    if (n.indexOf(o) >= 0) {
      a = o;
      let l = u(t, e);
      i = t.plus({ [o]: l }), i > e ? (t = t.plus({ [o]: l - 1 }), l -= 1) : t = i, s[o] = l;
    }
  return [t, s, i, a];
}
function Ds(t, e, n, r) {
  let [s, a, i, o] = ks(t, e, n);
  const u = e - s, l = n.filter(
    (p) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(p) >= 0
  );
  l.length === 0 && (i < e && (i = s.plus({ [o]: 1 })), i !== s && (a[o] = (a[o] || 0) + u / (i - s)));
  const d = g.fromObject(a, r);
  return l.length > 0 ? g.fromMillis(u, r).shiftTo(...l).plus(d) : d;
}
const lt = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Mt = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Ms = lt.hanidec.replace(/[\[|\]]/g, "").split("");
function Es(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const r = t.charCodeAt(n);
      if (t[n].search(lt.hanidec) !== -1)
        e += Ms.indexOf(t[n]);
      else
        for (const s in Mt) {
          const [a, i] = Mt[s];
          r >= a && r <= i && (e += r - a);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
function V({ numberingSystem: t }, e = "") {
  return new RegExp(`${lt[t || "latn"]}${e}`);
}
const Ns = "missing Intl.DateTimeFormat.formatToParts support";
function w(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(Es(n)) };
}
const bs = " ", On = `[ ${bs}]`, kn = new RegExp(On, "g");
function Is(t) {
  return t.replace(/\./g, "\\.?").replace(kn, On);
}
function Et(t) {
  return t.replace(/\./g, "").replace(kn, " ").toLowerCase();
}
function $(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(Is).join("|")),
    deser: ([n]) => t.findIndex((r) => Et(n) === Et(r)) + e
  };
}
function Nt(t, e) {
  return { regex: t, deser: ([, n, r]) => Ze(n, r), groups: e };
}
function He(t) {
  return { regex: t, deser: ([e]) => e };
}
function xs(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Cs(t, e) {
  const n = V(e), r = V(e, "{2}"), s = V(e, "{3}"), a = V(e, "{4}"), i = V(e, "{6}"), o = V(e, "{1,2}"), u = V(e, "{1,3}"), l = V(e, "{1,6}"), d = V(e, "{1,9}"), p = V(e, "{2,4}"), v = V(e, "{4,6}"), m = (f) => ({ regex: RegExp(xs(f.val)), deser: ([S]) => S, literal: !0 }), R = ((f) => {
    if (t.literal)
      return m(f);
    switch (f.val) {
      // era
      case "G":
        return $(e.eras("short", !1), 0);
      case "GG":
        return $(e.eras("long", !1), 0);
      // years
      case "y":
        return w(l);
      case "yy":
        return w(p, _e);
      case "yyyy":
        return w(a);
      case "yyyyy":
        return w(v);
      case "yyyyyy":
        return w(i);
      // months
      case "M":
        return w(o);
      case "MM":
        return w(r);
      case "MMM":
        return $(e.months("short", !0, !1), 1);
      case "MMMM":
        return $(e.months("long", !0, !1), 1);
      case "L":
        return w(o);
      case "LL":
        return w(r);
      case "LLL":
        return $(e.months("short", !1, !1), 1);
      case "LLLL":
        return $(e.months("long", !1, !1), 1);
      // dates
      case "d":
        return w(o);
      case "dd":
        return w(r);
      // ordinals
      case "o":
        return w(u);
      case "ooo":
        return w(s);
      // time
      case "HH":
        return w(r);
      case "H":
        return w(o);
      case "hh":
        return w(r);
      case "h":
        return w(o);
      case "mm":
        return w(r);
      case "m":
        return w(o);
      case "q":
        return w(o);
      case "qq":
        return w(r);
      case "s":
        return w(o);
      case "ss":
        return w(r);
      case "S":
        return w(u);
      case "SSS":
        return w(s);
      case "u":
        return He(d);
      case "uu":
        return He(o);
      case "uuu":
        return w(n);
      // meridiem
      case "a":
        return $(e.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return w(a);
      case "kk":
        return w(p, _e);
      // weekNumber (W)
      case "W":
        return w(o);
      case "WW":
        return w(r);
      // weekdays
      case "E":
      case "c":
        return w(n);
      case "EEE":
        return $(e.weekdays("short", !1, !1), 1);
      case "EEEE":
        return $(e.weekdays("long", !1, !1), 1);
      case "ccc":
        return $(e.weekdays("short", !0, !1), 1);
      case "cccc":
        return $(e.weekdays("long", !0, !1), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Nt(new RegExp(`([+-]${o.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return Nt(new RegExp(`([+-]${o.source})(${r.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return He(/[a-z_+-/]{1,256}?/i);
      default:
        return m(f);
    }
  })(t) || {
    invalidReason: Ns
  };
  return R.token = t, R;
}
const Fs = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};
function Vs(t, e, n) {
  const { type: r, value: s } = t;
  if (r === "literal")
    return {
      literal: !0,
      val: s
    };
  const a = n[r];
  let i = Fs[r];
  if (typeof i == "object" && (i = i[a]), i)
    return {
      literal: !1,
      val: i
    };
}
function $s(t) {
  return [`^${t.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, t];
}
function Ls(t, e, n) {
  const r = t.match(e);
  if (r) {
    const s = {};
    let a = 1;
    for (const i in n)
      if (te(n, i)) {
        const o = n[i], u = o.groups ? o.groups + 1 : 1;
        !o.literal && o.token && (s[o.token.val[0]] = o.deser(r.slice(a, a + u))), a += u;
      }
    return [r, s];
  } else
    return [r, {}];
}
function As(t) {
  const e = (a) => {
    switch (a) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return y(t.z) || (n = q.create(t.z)), y(t.Z) || (n || (n = new N(t.Z)), r = t.Z), y(t.q) || (t.M = (t.q - 1) * 3 + 1), y(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), y(t.u) || (t.S = nt(t.u)), [Object.keys(t).reduce((a, i) => {
    const o = e(i);
    return o && (a[o] = t[i]), a;
  }, {}), n, r];
}
let Pe = null;
function Zs() {
  return Pe || (Pe = h.fromMillis(1555555555555)), Pe;
}
function zs(t, e) {
  if (t.literal)
    return t;
  const n = b.macroTokenToFormatOpts(t.val);
  if (!n)
    return t;
  const a = b.create(e, n).formatDateTimeParts(Zs()).map((i) => Vs(i, e, n));
  return a.includes(void 0) ? t : a;
}
function Rs(t, e) {
  return Array.prototype.concat(...t.map((n) => zs(n, e)));
}
function Dn(t, e, n) {
  const r = Rs(b.parseFormat(n), t), s = r.map((i) => Cs(i, t)), a = s.find((i) => i.invalidReason);
  if (a)
    return { input: e, tokens: r, invalidReason: a.invalidReason };
  {
    const [i, o] = $s(s), u = RegExp(i, "i"), [l, d] = Ls(e, u, o), [p, v, m] = d ? As(d) : [null, null, void 0];
    if (te(d, "a") && te(d, "H"))
      throw new he(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: e, tokens: r, regex: u, rawMatches: l, matches: d, result: p, zone: v, specificOffset: m };
  }
}
function Us(t, e, n) {
  const { result: r, zone: s, specificOffset: a, invalidReason: i } = Dn(t, e, n);
  return [r, s, a, i];
}
const Mn = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], En = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function F(t, e) {
  return new L(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function Nn(t, e, n) {
  const r = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const s = r.getUTCDay();
  return s === 0 ? 7 : s;
}
function bn(t, e, n) {
  return n + (pe(t) ? En : Mn)[e - 1];
}
function In(t, e) {
  const n = pe(t) ? En : Mn, r = n.findIndex((a) => a < e), s = e - n[r];
  return { month: r + 1, day: s };
}
function tt(t) {
  const { year: e, month: n, day: r } = t, s = bn(e, n, r), a = Nn(e, n, r);
  let i = Math.floor((s - a + 10) / 7), o;
  return i < 1 ? (o = e - 1, i = $e(o)) : i > $e(e) ? (o = e + 1, i = 1) : o = e, { weekYear: o, weekNumber: i, weekday: a, ...ze(t) };
}
function bt(t) {
  const { weekYear: e, weekNumber: n, weekday: r } = t, s = Nn(e, 1, 4), a = ge(e);
  let i = n * 7 + r - s - 3, o;
  i < 1 ? (o = e - 1, i += ge(o)) : i > a ? (o = e + 1, i -= ge(e)) : o = e;
  const { month: u, day: l } = In(o, i);
  return { year: o, month: u, day: l, ...ze(t) };
}
function Ye(t) {
  const { year: e, month: n, day: r } = t, s = bn(e, n, r);
  return { year: e, ordinal: s, ...ze(t) };
}
function It(t) {
  const { year: e, ordinal: n } = t, { month: r, day: s } = In(e, n);
  return { year: e, month: r, day: s, ...ze(t) };
}
function Ws(t) {
  const e = Ae(t.weekYear), n = W(t.weekNumber, 1, $e(t.weekYear)), r = W(t.weekday, 1, 7);
  return e ? n ? r ? !1 : F("weekday", t.weekday) : F("week", t.week) : F("weekYear", t.weekYear);
}
function qs(t) {
  const e = Ae(t.year), n = W(t.ordinal, 1, ge(t.year));
  return e ? n ? !1 : F("ordinal", t.ordinal) : F("year", t.year);
}
function xn(t) {
  const e = Ae(t.year), n = W(t.month, 1, 12), r = W(t.day, 1, Ve(t.year, t.month));
  return e ? n ? r ? !1 : F("day", t.day) : F("month", t.month) : F("year", t.year);
}
function Cn(t) {
  const { hour: e, minute: n, second: r, millisecond: s } = t, a = W(e, 0, 23) || e === 24 && n === 0 && r === 0 && s === 0, i = W(n, 0, 59), o = W(r, 0, 59), u = W(s, 0, 999);
  return a ? i ? o ? u ? !1 : F("millisecond", s) : F("second", r) : F("minute", n) : F("hour", e);
}
const Je = "Invalid DateTime", Hs = 864e13;
function Ie(t) {
  return new L("unsupported zone", `the zone "${t.name}" is not supported`);
}
function Ge(t) {
  return t.weekData === null && (t.weekData = tt(t.c)), t.weekData;
}
function de(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new h({ ...n, ...e, old: n });
}
function Fn(t, e, n) {
  let r = t - e * 60 * 1e3;
  const s = n.offset(r);
  if (e === s)
    return [r, e];
  r -= (s - e) * 60 * 1e3;
  const a = n.offset(r);
  return s === a ? [r, s] : [t - Math.min(s, a) * 60 * 1e3, Math.max(s, a)];
}
function xt(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Fe(t, e, n) {
  return Fn(st(t), e, n);
}
function Ct(t, e) {
  const n = t.o, r = t.c.year + Math.trunc(e.years), s = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, a = {
    ...t.c,
    year: r,
    month: s,
    day: Math.min(t.c.day, Ve(r, s)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, i = g.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), o = st(a);
  let [u, l] = Fn(o, n, t.zone);
  return i !== 0 && (u += i, l = t.zone.offset(u)), { ts: u, o: l };
}
function fe(t, e, n, r, s, a) {
  const { setZone: i, zone: o } = n;
  if (t && Object.keys(t).length !== 0) {
    const u = e || o, l = h.fromObject(t, {
      ...n,
      zone: u,
      specificOffset: a
    });
    return i ? l : l.setZone(o);
  } else
    return h.invalid(
      new L("unparsable", `the input "${s}" can't be parsed as ${r}`)
    );
}
function xe(t, e, n = !0) {
  return t.isValid ? b.create(O.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function Be(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let r = "";
  return n && t.c.year >= 0 && (r += "+"), r += D(t.c.year, n ? 6 : 4), e ? (r += "-", r += D(t.c.month), r += "-", r += D(t.c.day)) : (r += D(t.c.month), r += D(t.c.day)), r;
}
function Ft(t, e, n, r, s, a) {
  let i = D(t.c.hour);
  return e ? (i += ":", i += D(t.c.minute), (t.c.second !== 0 || !n) && (i += ":")) : i += D(t.c.minute), (t.c.second !== 0 || !n) && (i += D(t.c.second), (t.c.millisecond !== 0 || !r) && (i += ".", i += D(t.c.millisecond, 3))), s && (t.isOffsetFixed && t.offset === 0 && !a ? i += "Z" : t.o < 0 ? (i += "-", i += D(Math.trunc(-t.o / 60)), i += ":", i += D(Math.trunc(-t.o % 60))) : (i += "+", i += D(Math.trunc(t.o / 60)), i += ":", i += D(Math.trunc(t.o % 60)))), a && (i += "[" + t.zone.ianaName + "]"), i;
}
const Vn = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Ps = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Ys = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, $n = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Js = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Gs = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Vt(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new Zt(t);
  return e;
}
function $t(t, e) {
  const n = Y(e.zone, M.defaultZone), r = O.fromObject(e), s = M.now();
  let a, i;
  if (y(t.year))
    a = s;
  else {
    for (const l of $n)
      y(t[l]) && (t[l] = Vn[l]);
    const o = xn(t) || Cn(t);
    if (o)
      return h.invalid(o);
    const u = n.offset(s);
    [a, i] = Fe(t, u, n);
  }
  return new h({ ts: a, zone: n, loc: r, o: i });
}
function Lt(t, e, n) {
  const r = y(n.round) ? !0 : n.round, s = (i, o) => (i = rt(i, r || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(i, o)), a = (i) => n.calendary ? e.hasSame(t, i) ? 0 : e.startOf(i).diff(t.startOf(i), i).get(i) : e.diff(t, i).get(i);
  if (n.unit)
    return s(a(n.unit), n.unit);
  for (const i of n.units) {
    const o = a(i);
    if (Math.abs(o) >= 1)
      return s(o, i);
  }
  return s(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function At(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
class h {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || M.defaultZone;
    let r = e.invalid || (Number.isNaN(e.ts) ? new L("invalid input") : null) || (n.isValid ? null : Ie(n));
    this.ts = y(e.ts) ? M.now() : e.ts;
    let s = null, a = null;
    if (!r)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [s, a] = [e.old.c, e.old.o];
      else {
        const o = n.offset(this.ts);
        s = xt(this.ts, o), r = Number.isNaN(s.year) ? new L("invalid input") : null, s = r ? null : s, a = r ? null : o;
      }
    this._zone = n, this.loc = e.loc || O.create(), this.invalid = r, this.weekData = null, this.c = s, this.o = a, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new h({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = At(arguments), [r, s, a, i, o, u, l] = n;
    return $t({ year: r, month: s, day: a, hour: i, minute: o, second: u, millisecond: l }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = At(arguments), [r, s, a, i, o, u, l] = n;
    return e.zone = N.utcInstance, $t({ year: r, month: s, day: a, hour: i, minute: o, second: u, millisecond: l }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const r = er(e) ? e.valueOf() : NaN;
    if (Number.isNaN(r))
      return h.invalid("invalid input");
    const s = Y(n.zone, M.defaultZone);
    return s.isValid ? new h({
      ts: r,
      zone: s,
      loc: O.fromObject(n)
    }) : h.invalid(Ie(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (_(e))
      return e < -864e13 || e > Hs ? h.invalid("Timestamp out of range") : new h({
        ts: e,
        zone: Y(n.zone, M.defaultZone),
        loc: O.fromObject(n)
      });
    throw new C(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (_(e))
      return new h({
        ts: e * 1e3,
        zone: Y(n.zone, M.defaultZone),
        loc: O.fromObject(n)
      });
    throw new C("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const r = Y(n.zone, M.defaultZone);
    if (!r.isValid)
      return h.invalid(Ie(r));
    const s = M.now(), a = y(n.specificOffset) ? r.offset(s) : n.specificOffset, i = Le(e, Vt), o = !y(i.ordinal), u = !y(i.year), l = !y(i.month) || !y(i.day), d = u || l, p = i.weekYear || i.weekNumber, v = O.fromObject(n);
    if ((d || o) && p)
      throw new he(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && o)
      throw new he("Can't mix ordinal dates with month/day");
    const m = p || i.weekday && !d;
    let T, R, f = xt(s, a);
    m ? (T = Js, R = Ps, f = tt(f)) : o ? (T = Gs, R = Ys, f = Ye(f)) : (T = $n, R = Vn);
    let S = !1;
    for (const oe of T) {
      const Zn = i[oe];
      y(Zn) ? S ? i[oe] = R[oe] : i[oe] = f[oe] : S = !0;
    }
    const E = m ? Ws(i) : o ? qs(i) : xn(i), Z = E || Cn(i);
    if (Z)
      return h.invalid(Z);
    const ae = m ? bt(i) : o ? It(i) : i, [Ln, An] = Fe(ae, a, r), Re = new h({
      ts: Ln,
      zone: r,
      o: An,
      loc: v
    });
    return i.weekday && d && e.weekday !== Re.weekday ? h.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${i.weekday} and a date of ${Re.toISO()}`
    ) : Re;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [r, s] = as(e);
    return fe(r, s, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [r, s] = os(e);
    return fe(r, s, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [r, s] = us(e);
    return fe(r, s, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, r = {}) {
    if (y(e) || y(n))
      throw new C("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: a = null } = r, i = O.fromOpts({
      locale: s,
      numberingSystem: a,
      defaultToEN: !0
    }), [o, u, l, d] = Us(i, e, n);
    return d ? h.invalid(d) : fe(o, u, r, `format ${n}`, e, l);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, r = {}) {
    return h.fromFormat(e, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [r, s] = ys(e);
    return fe(r, s, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new C("need to specify a reason the DateTime is invalid");
    const r = e instanceof L ? e : new L(e, n);
    if (M.throwOnInvalid)
      throw new Bn(r);
    return new h({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Ge(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Ge(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Ge(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Ye(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? be.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? be.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? be.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? be.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return pe(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Ve(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? ge(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? $e(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: r, calendar: s } = b.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(N.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(M.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (e = Y(e, M.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let s = this.ts;
      if (n || r) {
        const a = e.offset(this.ts), i = this.toObject();
        [s] = Fe(i, a, e);
      }
      return de(this, { ts: s, zone: e });
    } else
      return h.invalid(Ie(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    const s = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: r });
    return de(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = Le(e, Vt), r = !y(n.weekYear) || !y(n.weekNumber) || !y(n.weekday), s = !y(n.ordinal), a = !y(n.year), i = !y(n.month) || !y(n.day), o = a || i, u = n.weekYear || n.weekNumber;
    if ((o || s) && u)
      throw new he(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (i && s)
      throw new he("Can't mix ordinal dates with month/day");
    let l;
    r ? l = bt({ ...tt(this.c), ...n }) : y(n.ordinal) ? (l = { ...this.toObject(), ...n }, y(n.day) && (l.day = Math.min(Ve(l.year, l.month), l.day))) : l = It({ ...Ye(this.c), ...n });
    const [d, p] = Fe(l, this.o, this.zone);
    return de(this, { ts: d, o: p });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = g.fromDurationLike(e);
    return de(this, Ct(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = g.fromDurationLike(e).negate();
    return de(this, Ct(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e) {
    if (!this.isValid) return this;
    const n = {}, r = g.normalizeUnit(e);
    switch (r) {
      case "years":
        n.month = 1;
      // falls through
      case "quarters":
      case "months":
        n.day = 1;
      // falls through
      case "weeks":
      case "days":
        n.hour = 0;
      // falls through
      case "hours":
        n.minute = 0;
      // falls through
      case "minutes":
        n.second = 0;
      // falls through
      case "seconds":
        n.millisecond = 0;
        break;
    }
    if (r === "weeks" && (n.weekday = 1), r === "quarters") {
      const s = Math.ceil(this.month / 3);
      n.month = (s - 1) * 3 + 1;
    }
    return this.set(n);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? b.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : Je;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = je, n = {}) {
    return this.isValid ? b.create(this.loc.clone(n), e).formatDateTime(this) : Je;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? b.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: s = !0,
    extendedZone: a = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const i = e === "extended";
    let o = Be(this, i);
    return o += "T", o += Ft(this, i, n, r, s, a), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? Be(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return xe(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: s = !1,
    extendedZone: a = !1,
    format: i = "extended"
  } = {}) {
    return this.isValid ? (s ? "T" : "") + Ft(
      this,
      i === "extended",
      n,
      e,
      r,
      a
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return xe(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return xe(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Be(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (n || e) && (r && (s += " "), n ? s += "z" : e && (s += "ZZ")), xe(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Je;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", r = {}) {
    if (!this.isValid || !e.isValid)
      return g.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, a = tr(n).map(g.normalizeUnit), i = e.valueOf() > this.valueOf(), o = i ? this : e, u = i ? e : this, l = Ds(o, u, a, s);
    return i ? l.negate() : l;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(h.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? k.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n) {
    if (!this.isValid) return !1;
    const r = e.valueOf(), s = this.setZone(e.zone, { keepLocalTime: !0 });
    return s.startOf(n) <= r && r <= s.endOf(n);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || h.fromObject({}, { zone: this.zone }), r = e.padding ? this < n ? -e.padding : e.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], a = e.unit;
    return Array.isArray(e.unit) && (s = e.unit, a = void 0), Lt(n, this.plus(r), {
      ...e,
      numeric: "always",
      units: s,
      unit: a
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? Lt(e.base || h.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(h.isDateTime))
      throw new C("min requires all arguments be DateTimes");
    return ht(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(h.isDateTime))
      throw new C("max requires all arguments be DateTimes");
    return ht(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, r = {}) {
    const { locale: s = null, numberingSystem: a = null } = r, i = O.fromOpts({
      locale: s,
      numberingSystem: a,
      defaultToEN: !0
    });
    return Dn(i, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, r = {}) {
    return h.fromFormatExplain(e, n, r);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return je;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return zt;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Qn;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Rt;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Ut;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Wt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return qt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Ht;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Pt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Yt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Jt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Gt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Bt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return jt;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return _t;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Qt;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Kt;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return Kn;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Xt;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return en;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return tn;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return nn;
  }
}
function me(t) {
  if (h.isDateTime(t))
    return t;
  if (t && t.valueOf && _(t.valueOf()))
    return h.fromJSDate(t);
  if (t && typeof t == "object")
    return h.fromObject(t);
  throw new C(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const Bs = zn({
  name: "vs-calendar",
  components: {
    Calendar: Hn,
    DatePicker: qn,
    vsIcon: Pn,
    vsButton: Yn,
    vsBadge: Jn
  },
  props: {
    useInputs: { type: Boolean, default: !1 },
    forcedDates: {
      type: Object,
      default: null
    },
    title: { type: String, default: null },
    maxDaysRange: { type: Number, default: void 0 },
    color: { type: String, default: "indigo" },
    badgeColor: { type: String, default: "primary" },
    maxDate: { type: Date, default: void 0 },
    minDate: { type: Date, default: void 0 },
    mode: { type: String, default: "date" },
    timezone: { type: String, default: Intl.DateTimeFormat().resolvedOptions().timeZone }
  },
  emits: ["dates:changed"],
  setup(t, { emit: e }) {
    const n = J(null), r = J(t.forcedDates), s = J(r.value), a = J({
      hours: 23,
      minutes: 59,
      seconds: 59,
      milliseconds: 999
    }), i = Oe(() => ["range", "dateTimeRange"].includes(t.mode));
    r.value || (t.mode === "multiple" && (r.value = []), i.value && (r.value = {
      start: null,
      end: null
    }));
    const o = J(!1), u = Oe(() => [
      {
        key: "today",
        dot: "purple",
        dates: /* @__PURE__ */ new Date()
      },
      ...t.mode === "multiple" ? [{
        highlight: {
          color: t.color,
          fillMode: "light"
        },
        dates: r.value.map((f) => f.date)
      }] : []
    ]), l = J(!1);
    ue(() => t.forcedDates, () => {
      o.value = !0, r.value = t.forcedDates;
    });
    const d = Oe(() => {
      var f, S;
      return (f = r.value) != null && f.start && ((S = r.value) != null && S.end) ? t.mode === "dateTimeRange" ? {
        start: h.fromJSDate(r.value.start).toJSDate(),
        end: h.fromJSDate(r.value.end).toJSDate()
      } : {
        start: h.fromJSDate(r.value.start).startOf("day").toJSDate(),
        end: h.fromJSDate(r.value.end).endOf("day").toJSDate()
      } : r.value || {};
    });
    ue(d, () => {
      o.value ? o.value = !1 : e("dates:changed", d.value);
    }, { deep: !0 }), ue(s, () => {
      t.mode !== "multiple" && e("dates:changed", s.value);
    }, { deep: !0 }), ue(() => {
      var f;
      return (f = r.value) == null ? void 0 : f.start;
    }, () => {
      var f, S, E;
      (!((f = r.value) != null && f.end) || ((S = r.value) == null ? void 0 : S.start) > ((E = r.value) == null ? void 0 : E.end)) && (l.value = !0, r.value.end = r.value.start);
    }), ue(() => {
      var f;
      return (f = r.value) == null ? void 0 : f.end;
    }, () => {
      var f, S, E;
      (!((f = r.value) != null && f.start) || ((S = r.value) == null ? void 0 : S.end) < ((E = r.value) == null ? void 0 : E.start)) && (l.value = !0, r.value.start = r.value.end);
    });
    const p = (f, S) => {
      if (S.target.blur(), i.value && (n.value = f.date), t.mode === "multiple") {
        const E = r.value.findIndex((Z) => Z.id === f.id);
        if (E >= 0)
          r.value.splice(E, 1);
        else {
          const Z = r.value.findIndex((ae) => new Date(ae.date) > new Date(f.date));
          Z === -1 ? r.value.push({
            id: f.id,
            date: f.date
          }) : r.value.splice(Z, 0, {
            id: f.id,
            date: f.date
          });
        }
        Rn(() => {
          s.value = null;
        });
      }
    }, v = Oe(() => {
      if (t.maxDaysRange && n.value) {
        const f = h.fromJSDate(t.maxDate).startOf("day");
        h.now();
        const S = h.fromJSDate(n.value).plus({ days: t.maxDaysRange });
        return S.startOf("day") > f ? f.toJSDate() : S.toJSDate();
      }
      return t.maxDate;
    }), m = (f) => {
      if (!f) return "-";
      f.charAt && Number(f.charAt(f.length - 1)) && (f += "Z");
      const S = new Date(f), E = navigator.language;
      if (["dateTime", "dateTimeRange"].includes(t.mode)) {
        const Z = new Intl.DateTimeFormat(E, { dateStyle: "short" }).format(S), ae = new Intl.DateTimeFormat(E, {
          hour: "numeric",
          minute: "numeric"
          // hour12: true
        }).format(S);
        return `${Z} - ${ae}`;
      } else
        return new Intl.DateTimeFormat(E, { dateStyle: "short" }).format(S);
    }, T = J();
    return { dates: r, parsedDates: d, attributes: u, rules: a, computedMaxDate: v, handleClick: p, formatDate: m, button: T, selectedDate: s, removeDate: (f, S) => {
      r.value = r.value.filter((E) => E !== f), S();
    } };
  }
}), js = { key: 0 }, _s = { class: "font-bold ml-2 mb-2" }, Qs = { class: "flex space-x-2 items-center mb-2" }, Ks = { key: 1 }, Xs = { class: "font-bold ml-2 mb-2" }, ei = { key: 2 }, ti = { class: "font-bold ml-2" }, ni = ["onClick"], ri = { class: "flex flex-wrap" }, si = ["onClick"];
function ii(t, e, n, r, s, a) {
  const i = ke("vs-button"), o = ke("date-picker"), u = ke("vs-icon"), l = ke("vs-badge");
  return ["range", "dateTimeRange"].includes(t.mode) ? (K(), De("div", js, [
    z("div", _s, Ue(t.title), 1),
    z("div", Qs, [
      U(o, dt({
        mode: t.mode === "dateTimeRange" ? "dateTime" : "date",
        is24hr: "",
        modelValue: t.dates.start,
        "onUpdate:modelValue": e[0] || (e[0] = (d) => t.dates.start = d)
      }, t.$attrs, {
        value: null,
        color: t.color,
        attributes: t.attributes,
        "max-date": t.computedMaxDate,
        "min-date": t.minDate,
        timezone: t.timezone,
        "is-required": "",
        "input-debounce": 500,
        onDayclick: t.handleClick
      }), {
        default: le(({ togglePopover: d }) => [
          e[4] || (e[4] = z("div", { class: "flex justify-center items-center" }, null, -1)),
          U(i, {
            class: ft(["bg-white border px-2 py-1 rounded w-28", t.mode === "dateTime" ? "w-36" : "w-28"]),
            kind: "flat",
            text: t.formatDate(t.parsedDates.start),
            onClick: d
          }, null, 8, ["class", "text", "onClick"])
        ]),
        _: 1
      }, 16, ["mode", "modelValue", "color", "attributes", "max-date", "min-date", "timezone", "onDayclick"]),
      U(u, { name: "ooui:arrow-next-ltr" }),
      U(o, dt({
        mode: t.mode === "dateTimeRange" ? "dateTime" : "date",
        is24hr: "",
        modelValue: t.dates.end,
        "onUpdate:modelValue": e[1] || (e[1] = (d) => t.dates.end = d),
        rules: t.rules
      }, t.$attrs, {
        value: null,
        color: t.color,
        attributes: t.attributes,
        "max-date": t.computedMaxDate,
        timezone: t.timezone,
        "is-required": "",
        "input-debounce": 500,
        onDayclick: t.handleClick
      }), {
        default: le(({ togglePopover: d }) => [
          e[5] || (e[5] = z("div", { class: "flex justify-center items-center" }, null, -1)),
          U(i, {
            class: "bg-white border px-2 py-1 rounded w-28",
            kind: "flat",
            text: t.formatDate(t.parsedDates.end),
            onClick: d
          }, null, 8, ["text", "onClick"])
        ]),
        _: 1
      }, 16, ["mode", "modelValue", "rules", "color", "attributes", "max-date", "timezone", "onDayclick"])
    ])
  ])) : ["date", "dateTime"].includes(t.mode) ? (K(), De("div", Ks, [
    z("div", Xs, Ue(t.title), 1),
    U(o, {
      modelValue: t.selectedDate,
      "onUpdate:modelValue": e[2] || (e[2] = (d) => t.selectedDate = d),
      mode: t.mode,
      value: null,
      color: t.color,
      attributes: t.attributes,
      "max-date": t.computedMaxDate,
      "min-date": t.minDate,
      timezone: t.timezone,
      "is-required": "",
      is24hr: "",
      "input-debounce": 500,
      onDayclick: t.handleClick
    }, {
      default: le(({ togglePopover: d }) => [
        e[6] || (e[6] = z("div", { class: "flex justify-center items-center" }, null, -1)),
        U(i, {
          class: ft(["bg-white border px-2 py-1 rounded", t.mode === "dateTime" ? "w-36" : "w-28"]),
          kind: "flat",
          text: t.formatDate(t.selectedDate),
          onClick: d,
          onDayclick: t.handleClick
        }, null, 8, ["class", "text", "onClick", "onDayclick"])
      ]),
      _: 1
    }, 8, ["modelValue", "mode", "color", "attributes", "max-date", "min-date", "timezone", "onDayclick"])
  ])) : t.mode === "multiple" ? (K(), De("div", ei, [
    z("div", ti, Ue(t.title), 1),
    U(o, {
      modelValue: t.selectedDate,
      "onUpdate:modelValue": e[3] || (e[3] = (d) => t.selectedDate = d),
      color: t.color,
      attributes: t.attributes,
      onDayclick: t.handleClick
    }, {
      default: le(({ inputValue: d, togglePopover: p, showPopover: v, hidePopover: m }) => [
        z("button", {
          class: "text-sm text-primary font-semibold hover:text-primary-700 px-2 h-8 focus:outline-none",
          onClick: Me(p, ["stop"])
        }, " + Agregar fecha ", 8, ni),
        z("div", ri, [
          (K(!0), De(Un, null, Wn(t.dates.slice(0, 5), (T, R) => (K(), mt(l, {
            color: `${t.badgeColor}-container`,
            key: T.date.getTime(),
            text: T.date.toLocaleDateString(),
            class: "flex items-center text-sm pl-2 cursor-pointer font-bold mx-0.5 mt-0.5 overflow-hidden",
            onClick: Me((f) => {
              v(f), t.selectedDate = T.date;
            }, ["stop"])
          }, {
            after: le(() => [
              z("div", {
                class: "hover:bg-black/10 ease-in duration-100 flex items-center",
                id: "close",
                onClick: Me((f) => t.removeDate(T, m), ["stop"])
              }, [
                U(u, {
                  color: `${t.badgeColor}-600`,
                  name: "ci:close-small",
                  animation: "pulse",
                  width: "24",
                  height: "24",
                  class: "pointer-events-none"
                }, null, 8, ["color"])
              ], 8, si)
            ]),
            _: 2
          }, 1032, ["color", "text", "onClick"]))), 128)),
          t.dates.length > 5 ? (K(), mt(l, {
            key: 0,
            color: `${t.badgeColor}-container`,
            text: `+${t.dates.length - 5}`,
            class: "flex items-center text-sm px-2 cursor-pointer font-bold mx-0.5 mt-0.5 overflow-hidden",
            onClick: Me(v, ["stop"])
          }, null, 8, ["color", "text", "onClick"])) : ct("", !0)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "color", "attributes", "onDayclick"])
  ])) : ct("", !0);
}
const fi = /* @__PURE__ */ Gn(Bs, [["render", ii]]);
export {
  fi as v
};
//# sourceMappingURL=vsCalendar-Cj3ZLH8g.mjs.map
